import { AppData, BookingData, Step } from "../../AppDataProvider";

import { BackFromDetailsStepPayload } from "../../actions";
import { getDetailsPreviousStep } from "../../../utils";
import { Mixpanel } from "../../../mixpanel";

export type BackFromDetailsStepOpts = {
  appData: AppData;
  payload: BackFromDetailsStepPayload;
};

export const backFromDetailsStep = (
  options: BackFromDetailsStepOpts,
): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "details" } });
  const urlParams = new URLSearchParams(window.location.search);
  const prefilledOrganisationId = urlParams.get("organisationId");

  const appData = options.appData;
  const { bookingData, bookingTool } = appData;

  const { userDetails: newUserDetails } = options.payload.updatedData;
  const updatedBookingData: BookingData = {
    ...bookingData,
    userDetails: {
      ...bookingData.userDetails,
      ...newUserDetails,
    },
  };

  const previousStep: Step = getDetailsPreviousStep({
    bookingData,
    bookingTool,
  });

  if (previousStep === "locationAvailability" && !prefilledOrganisationId) {
    delete updatedBookingData.resource;
    delete updatedBookingData.service;
    delete updatedBookingData.organisation;
  }

  if (previousStep === "resources") {
    delete updatedBookingData.resource;
    delete updatedBookingData.resourceGroupId;
  }

  return {
    ...appData,
    bookingData: updatedBookingData,
    currentStep: previousStep,
  };
};
